<ew-mat-dialog-custom>
  <ew-mat-stepper-custom
    [validations]="[true]"
    [alignItems]="'center'"
    [sendIn]="'penultimate'"
    (send)="send()">
    <ew-mat-stepper-custom-step>
      <div class="text-center grid gap-4 max-w-2xl m-auto">
        <div class="mb-5 text-5xl font-bold">
          {{ 'creditPayment:title1' | translate }} {{ data.amount }}
          {{ data.currency }} {{ 'creditPayment:title2' | translate }}
        </div>
        <div class="">{{ 'creditPayment:subtitle' | translate }}</div>
      </div>
    </ew-mat-stepper-custom-step>

    <ew-mat-stepper-custom-step>
      <mat-progress-spinner
        class="m-auto my-5"
        [diameter]="24"
        [mode]="'indeterminate'"
        *ngIf="loading"></mat-progress-spinner>

      <div
        class="text-center grid gap-4 max-w-2xl"
        *ngIf="!loading && !success">
        <img
          class="w-10 m-auto"
          width="150"
          src="assets/circle-error.svg"
          alt="" />
        <div class="mb-5 text-5xl font-bold">
          {{ 'creditPayment:statusErrorTitle' | translate }}
        </div>
        <div class="">
          {{ 'creditPayment:statusErrorSubtitle' | translate }}
        </div>
      </div>
    </ew-mat-stepper-custom-step>
  </ew-mat-stepper-custom>
</ew-mat-dialog-custom>
